var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notification',{attrs:{"icon":"fa-info","type":"is-info","snackbar":""},on:{"delete":function($event){return _vm.$emit('delete')}}},[_vm._v("\n  Nastąpiło poprawne wylogowanie z panelu administratora.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }